import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LiaTripadvisor } from "react-icons/lia";
import { useTranslation } from "react-i18next";
import axios from "axios";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };


  // topbar detail 
     const [ContactDetail, setContactDetail] = useState([]);
      useEffect(() => {
      const fetchData = async () => {
        const response = await axios.get(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/contact_info_list"
        );
        setContactDetail([response.data.data]);
      };
  
      fetchData();
    }, []);

    // home detail 
      const [HomeDetail, setHomeDetail] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/home_details_list"
      );
      setHomeDetail([response.data.data]);
    };

    fetchData();
  }, []);

  return (
    <div>
      <ScrollToTop />
      {/* Offcanvas Menu Section Begin */}
      <div
        className={`offcanvas-menu-overlay ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(false)}
      />

      <div className="canvas-open" onClick={() => setIsOpen(true)}>
        <i className="fa-solid fa-bars-staggered"></i>
      </div>

      <div
        className={`offcanvas-menu-wrapper ${
          isOpen ? "show-offcanvas-menu-wrapper" : ""
        }`}
      >
        <div className="canvas-close" onClick={() => setIsOpen(false)}>
          <i className="fa-solid fa-xmark" />
        </div>

        <div className="header-configure-area">
          <Link to="/book-now" className="bk-btn" onClick={() => setIsOpen(false)}>
            {t("bookingNow")}
          </Link>
        </div>

        <div id="mobile-menu-wrap">
          <div className="slicknav_menu">
            <nav
              className="slicknav_nav slicknav_hidden"
              aria-hidden="true"
              role="menu"
              style={{ display: "none" }}
            >
              <ul>
                <li className="active">
                  <Link to="/" onClick={() => setIsOpen(false)}>
                    {t("home")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                <li>
                  <Link to="/location" onClick={() => setIsOpen(false)}>
                    {t("location")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                <li>
                  <Link to="/book-now" onClick={() => setIsOpen(false)}>
                    {t("rooms")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                <li>
                  <Link to="/our-rooms" onClick={() => setIsOpen(false)}>
                    {t("amenities")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                <li>
                  <Link to="/contact" onClick={() => setIsOpen(false)}>
                    {t("contact")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>

                <li>
                  <Link to="/gallery" onClick={() => setIsOpen(false)}>
                    {t("gallery")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                <li>
                  <Link to="/policies" onClick={() => setIsOpen(false)}>
                    {t("policies")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                  <li>
                  <Link to="/blog" onClick={() => setIsOpen(false)}>
                    {t("blog")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
                <li>
                  <Link to="/feedback" onClick={() => setIsOpen(false)}>
                    {t("feedback")}
                  </Link>
                  <div className="horizontal-line"></div>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* desktop view  */}
        <div className="top-social">
  <a
    href="https://www.facebook.com/Silver-Apartment-Hotel-Manish-Nagar-Nagpur-61578971163827/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa-brands fa-facebook-f" />
  </a>
  
  <a
    href="https://www.instagram.com/silver.apartment.hotel.nagpur/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa-brands fa-instagram" />
  </a>
</div>




          {ContactDetail.map((item, index) => (
        <ul className="top-widget" key={index}>

          <li>
            <i className="fa fa-phone" /> {item.cont_phone}
          </li>
          <li>
            <i className="fa fa-envelope" /> {item.cont_email}
          </li>
        </ul>
          ))}
      </div>

      {/* Offcanvas Menu Section End */}

      <header className="header-section header-normal">
        <div className="top-nav">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                {ContactDetail.map((item, index) => (
                <ul className="tn-left">
                  <li>
                    <i className="fa fa-phone" /> {item.cont_phone}
                  </li>
                  <li>
                    <i className="fa fa-envelope" /> {item.cont_email}
                  </li>
                </ul>
                ))}
              </div>
              <div className="col-lg-6">
                <div className="tn-right">
                  <div className="top-social">
                     <a
    href="https://www.facebook.com/Silver-Apartment-Hotel-Manish-Nagar-Nagpur-61578971163827/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa-brands fa-facebook-f" />
  </a>
  <a
    href="https://www.instagram.com/silver.apartment.hotel.nagpur/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa-brands fa-instagram" />
  </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="menu-item mobile-item">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-1">
                {HomeDetail.map((data, index) => {
                  const words = data.web_title.split(" ");

                  return (
                <div className="logo" key={index}>
                  <Link to="/">
                    <img src={`https://cyberathon.com/silverapartment/${data.logo_img}`} loading="lazy" alt="Hotel Logo" />
                  </Link>
                  <div className="mobile-logo-name">
                  <p className="d-lg-none">
                    {words.map((word, i) => (
                    <span
                      style={{
                        color: i === 0 ? "#ec2027" : "#333694",
                        fontSize: "22px",
                        fontWeight: "800",
                        marginRight:"5px"
                      }}
                    >
                      {word}
                    </span>
                  ))}
                  </p>
                  <p className="d-lg-none">
                    <span className="mobile-logo-des">{data.wed_subtitle}</span>
                  </p>
                  </div>
                </div>
                )})}
              </div>
              <div className="col-lg-3">
  <div className="logo-name">
    {HomeDetail.map((data, index) => {
      const words = data.web_title.split(" ");

      return (
        <div key={index}>
          <h1 style={{ margin: 0, padding: 0, fontSize: "30px", fontWeight: "600", fontFamily: "inherit", textAlign:"center" }}>
            {words.map((word, i) => (
              <span
                key={i}
                style={{
                  color: i === 0 ? "#ec2027" : "#333694",
                  fontSize: "30px",
                  fontWeight: "600",
                  marginRight: "5px",
                  marginTop: "5px",
                  display: "inline-block",
                  fontFamily: "inherit"
                }}
              >
                {word}
              </span>
            ))}
          </h1>
          <h2 style={{fontSize: "16px", fontFamily: "Cabin, sans-serif", color:" #6b6b6b", fontWeight: "400", lineHeight: "26px", margin: "0 0 15px 0" , display:"flex", alignItems:"center", justifyContent:"center"}}>
            <span className="logo-des">{data.wed_subtitle}</span>
          </h2>
        </div>
      );
    })}
  </div>
</div>

              <div className="col-lg-8">
                <div className="nav-menu">
                  <nav className="mainmenu">
                    <ul>

                      <li className={location.pathname === "/" ? "active" : ""}>
                        <Link to="/">{t("home")}</Link>
                      </li>

                      <li
                        className={
                          location.pathname === "/location" ? "active" : ""
                        }
                      >
                        <Link to="/location">{t("location")}</Link>
                      </li>
                      <li
                        className={
                          location.pathname === "/book-now" ? "active" : ""
                        }
                      >
                        <Link to="/book-now">{t("rooms")}</Link>
                      </li>
                      <li
                        className={
                          location.pathname === "/gallery" ? "active" : ""
                        }
                      >
                        <Link to="/gallery">{t("gallery")}</Link>
                      </li>
                      <li
                        className={
                          location.pathname === "/our-rooms" ? "active" : ""
                        }
                      >
                        <Link to="/our-rooms">{t("amenities")}</Link>
                      </li>
                      <li
                        className={
                          location.pathname === "/contact" ? "active" : ""
                        }
                      >
                        <Link to="/contact">{t("contact")}</Link>
                      </li>
                      <li
                        className={
                          location.pathname === "/policies" ? "active" : ""
                        }
                      >
                        <Link to="/policies">{t("policies")}</Link>
                      </li>

                        <li
                        className={
                          location.pathname === "/blog" ? "active" : ""
                        }
                      >
                        <Link to="/blog">{t("blog")}</Link>
                      </li>

                      <li
                        className={
                          location.pathname === "/feedback" ? "active" : ""
                        }
                      >
                        <Link to="/feedback">{t("feedback")}</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
